import { DollarSign, Heart, Target, Home, Leaf, Sparkles } from "lucide-react";

export const transformationAreas = [
  {
    icon: DollarSign,
    title: "💰 Finanças e Prosperidade",
    description: "Desbloqueie crenças limitantes sobre dinheiro, descubra seus talentos lucrativos e atraia abundância financeira através do seu perfil numerológico.",
    gradientFrom: "green-500/30",
    gradientTo: "green-600/30",
    iconColor: "green-400"
  },
  {
    icon: Heart,
    title: "❤️ Relacionamentos e Amor",
    description: "Entenda seus padrões amorosos, rompa ciclos tóxicos, melhore a comunicação e atraia relacionamentos saudáveis e duradouros.",
    gradientFrom: "pink-500/30",
    gradientTo: "rose-600/30",
    iconColor: "pink-400"
  },
  {
    icon: Target,
    title: "🎯 Carreira e Propósito",
    description: "Descubra sua missão de vida, identifique carreiras alinhadas com seu propósito e tome decisões profissionais mais assertivas.",
    gradientFrom: "blue-500/30",
    gradientTo: "indigo-600/30",
    iconColor: "blue-400"
  },
  {
    icon: Home,
    title: "🏠 Família e Lar",
    description: "Harmonize conflitos familiares, entenda dinâmicas hereditárias e crie um ambiente doméstico mais equilibrado e próspero.",
    gradientFrom: "orange-500/30",
    gradientTo: "amber-600/30",
    iconColor: "orange-400"
  },
  {
    icon: Leaf,
    title: "🌱 Saúde e Bem-estar",
    description: "Compreenda seu corpo energético, desenvolva rotinas saudáveis personalizadas e equilibre aspectos físicos, mentais e espirituais.",
    gradientFrom: "green-600/30",
    gradientTo: "emerald-600/30",
    iconColor: "green-400"
  },
  {
    icon: Sparkles,
    title: "🔮 Arcanos e Simbolismo",
    description: "Descubra quais energias estão presentes na sua vida, entenda o significado especial de cada uma e receba orientações valiosas para te ajudar a fazer escolhas com mais confiança e clareza no seu dia a dia.",
    gradientFrom: "purple-500/30",
    gradientTo: "violet-600/30",
    iconColor: "purple-400"
  }
];